import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=2724ef16&scoped=true&"
import script from "./Contracts.vue?vue&type=script&lang=ts&"
export * from "./Contracts.vue?vue&type=script&lang=ts&"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=2724ef16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2724ef16",
  null
  
)

export default component.exports